import { z } from 'zod'

const LocationQtySchema = z.object({
  location: z.string(),
  qty: z.number(),
})

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  itemId: z.number(),
  lotNo: z.string(),
  lotDate: z.coerce.date(),
  mold: z.string(),
  isClaimItem: z.boolean(),
  unit: z.string(),
  qty: z.number(),
  refNo: z.string().nullish(),
  isLocationFulfilled: z.boolean(),
  locations: z.array(LocationQtySchema),
})

export const Inv1310GetResultSchema = z.object({
  number: z.string(),
  date: z.coerce.date(),
  partyId: z.number(),
  refNo: z.string().nullable(),
  refDate: z.coerce.date().nullable(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  status: z.number(),
  isFulfilled: z.boolean().nullable(),
  confirmed: z.boolean().optional(),
  confirmInfo: z.object({
    date: z.coerce.date().nullable(),
    byName: z.string().optional(),
    remark: z.string().optional(),
  }),
})

export type Inv1310GetResultModel = z.input<typeof Inv1310GetResultSchema>
